// extracted by mini-css-extract-plugin
export default {"container":"meHeader-module__container___-AiPK","image":"meHeader-module__image___3dSxY","info":"meHeader-module__info___SnSXp","socials":"meHeader-module__socials___iIwMw"};